import { render, staticRenderFns } from "./PreselectCards.vue?vue&type=template&id=08fb8b6c&"
import script from "./PreselectCards.vue?vue&type=script&lang=js&"
export * from "./PreselectCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports